import { createSelector } from '@reduxjs/toolkit'

import { getPracticesState } from '../../data/practicesSelectors'

export const getPracticeDetails = createSelector(getPracticesState, (practicesState) => practicesState.practiceDetails)

export const getPracticeDetailsAddProviderModalShown = createSelector(
  getPracticeDetails,
  (practiceDetailsState) => practiceDetailsState.addProviderModalShown,
)

export const getPracticeDetailsData = createSelector(
  getPracticeDetails,
  (practiceDetailsState) => practiceDetailsState.data,
)

export const getPracticeDetailsDataId = createSelector(
  getPracticeDetailsData,
  (practiceDetailsState) => practiceDetailsState?.id,
)

export const getPracticeDetailsProviders = createSelector(
  getPracticeDetails,
  (practiceDetailsState) => practiceDetailsState.providers,
)
